export default __webpack_public_path__ + "static/media/check.991f107b.svg";